import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [blink, setBlink] = useState(false);
  const [isRetired, setIsRetired] = useState(false);
  const [daysRetired, setDaysRetired] = useState(0);

  const TOTAL_CUBES = 7305;

  useEffect(() => {
    const calculateTime = () => {
      const targetDate = new Date('2026-01-30T00:00:00');
      const now = new Date();

      // Calculate to the start of today (midnight last night)
      const startOfToday = new Date(now);
      startOfToday.setHours(0, 0, 0, 0);

      const difference = targetDate - now;
      const differenceFromStartOfToday = targetDate - startOfToday;

      if (difference > 0) {
        // Not yet retired - count down
        setIsRetired(false);
        setDaysRetired(0);

        // Days remaining = includes today until midnight, then decrements
        const days = Math.ceil(differenceFromStartOfToday / (1000 * 60 * 60 * 24)) - 1;
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        setTimeLeft({ days, hours, minutes, seconds });

        // Toggle blink state based on even/odd seconds
        setBlink(seconds % 2 === 0);
      } else {
        // Retired! Count up from retirement date
        setIsRetired(true);

        const timeSinceRetirement = now - targetDate;
        const days = Math.floor(timeSinceRetirement / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeSinceRetirement / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((timeSinceRetirement / 1000 / 60) % 60);
        const seconds = Math.floor((timeSinceRetirement / 1000) % 60);

        setTimeLeft({ days, hours, minutes, seconds });
        setDaysRetired(days + 1); // +1 to include today

        // Toggle blink state based on even/odd seconds
        setBlink(seconds % 2 === 0);
      }
    };

    calculateTime();
    const timer = setInterval(calculateTime, 1000);

    return () => clearInterval(timer);
  }, []);

  const renderCubes = () => {
    const cubes = [];

    if (isRetired) {
      // Render green cubes for days retired
      for (let i = 0; i < daysRetired; i++) {
        const isToday = i === daysRetired - 1;
        cubes.push(
          <div
            key={`retired-${i}`}
            className={`cube retired ${isToday ? 'today' : ''} ${isToday && blink ? 'blink-retired' : ''}`}
          />
        );
      }

      // Then render grey cubes for remaining career
      for (let i = 0; i < TOTAL_CUBES - daysRetired; i++) {
        cubes.push(
          <div
            key={`grey-${i}`}
            className="cube"
          />
        );
      }
    } else {
      const daysRemaining = timeLeft.days;
      const todayIndex = daysRemaining - 1; // Last white cube represents today

      // Render highlighted (white) cubes first
      for (let i = 0; i < daysRemaining; i++) {
        const isToday = i === todayIndex;
        cubes.push(
          <div
            key={`highlighted-${i}`}
            className={`cube highlighted ${isToday ? 'today' : ''} ${isToday && blink ? 'blink-sharp' : ''}`}
          />
        );
      }

      // Then render grey cubes
      for (let i = 0; i < TOTAL_CUBES - daysRemaining; i++) {
        cubes.push(
          <div
            key={`grey-${i}`}
            className="cube"
          />
        );
      }
    }

    return cubes;
  };

  return (
    <div className="App">
      <h1 className={isRetired ? "yes-text" : "no-text"}>{isRetired ? "Yes." : "No."}</h1>
      <div className="countdown-text">
        {isRetired ? "Steve's been retired for" : "Steve does not retire for"}
      </div>
      <div className="countdown">
        <div className="time-unit">
          <span className="number">{timeLeft.days}</span>
          <span className="label">days</span>
        </div>
        <div className="time-unit">
          <span className="number">{timeLeft.hours}</span>
          <span className="label">hours</span>
        </div>
        <div className="time-unit">
          <span className="number">{timeLeft.minutes}</span>
          <span className="label">minutes</span>
        </div>
        <div className="time-unit">
          <span className="number">{timeLeft.seconds}</span>
          <span className="label">seconds</span>
        </div>
      </div>
      <div className="cubes-container">
        {renderCubes()}
      </div>
      <div className="legend">
        {isRetired ? (
          <>
            <div className="legend-item">
              <div className="legend-cube green"></div>
              <span className="legend-label">Days Retired</span>
            </div>
            <div className="legend-item">
              <div className="legend-cube grey"></div>
              <span className="legend-label">Days Employed</span>
            </div>
          </>
        ) : (
          <>
            <div className="legend-item">
              <div className="legend-cube white"></div>
              <span className="legend-label">Days Left</span>
            </div>
            <div className="legend-item">
              <div className="legend-cube grey"></div>
              <span className="legend-label">Days Employed</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
